import { Slide, useScrollTrigger } from '@mui/material';
import { PropsWithChildren } from 'react';

export default function HideOnScroll({
  children,
}: Readonly<PropsWithChildren>) {
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction='down' in={!trigger}>
      {children}
    </Slide>
  );
}
